import {useCustomQuery} from "../../../query/queryClient";
import {queryHttp} from "../../../query/queryHttp";
import {supplierKpiSummaryUrl} from "../services/supplier360Urls";
import type {SupplierKpiSummary} from "../types/Supplier360Types";

/**
 * The profile header's KPI strip (`GET supplier_360/entity/{id}/kpi_summary/`).
 * A plain aggregate action, not a paginated list — the response is the object itself.
 */
export function useSupplierKpiSummaryQuery(entityId: number | undefined) {
    const url = supplierKpiSummaryUrl(entityId ?? 0);
    return useCustomQuery({
        queryKey: [url] as const,
        queryFn: async () => (await queryHttp.get<SupplierKpiSummary>(url)).data,
        enabled: Boolean(entityId),
    });
}
